import { render, staticRenderFns } from "./DialogRemark.vue?vue&type=template&id=3f76b350"
import script from "./DialogRemark.vue?vue&type=script&lang=js"
export * from "./DialogRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports